/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Download32 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="currentColor" d="M9 23h14v2H9zm6-17h2v14h-2z" />
      <path stroke="currentColor" strokeLinecap="square" strokeWidth={2} d="m21 15-5 5-5-5" />
    </g>
  </svg>
);

export const __descriptor_Download = {
  name: "Download",
  instances: [{ size: 32, Component: Download32 }],
} as const;
